// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { MISSING_ALIAS } from "@/hooks/useAliasRenderer";
// Names the item by the alias the tree shows, or keeps the generic message
// when the item has neither an alias nor a name.
export var getMenuActionConfirmMessage = function (t, action, name) {
    var target = name === null || name === void 0 ? void 0 : name.trim();
    return String(target && target !== MISSING_ALIAS
        ? t("sideMenu.menuActions.messages.confirm.".concat(action, "Named"), { name: target })
        : t("sideMenu.menuActions.messages.confirm.".concat(action)));
};
